import React, { FunctionComponent } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  LabelList,
} from "recharts";

const data = [
  {
    name: "Week 1",
    uv: 400,
    //pv: 200,
    amt: 2400,
  },
  {
    name: "Week 2",
    uv: 300,
    //pv: 198,
    amt: 2210,
  },
  {
    name: "Week 3",
    uv: 200,
    //pv: 800,
    amt: 2290,
  },
  {
    name: "Week 4",
    uv: 280,
    //pv: 308,
    amt: 2000,
  },
  {
    name: "Week 5",
    uv: 180,
    //pv: 400,
    amt: 2181,
  },
  {
    name: "Week 6",
    uv: 290,
    //pv: 300,
    amt: 2500,
  },
  {
    name: "Week 7",
    uv: 490,
    // pv: 400,
    amt: 2100,
  },
];

const CustomizedAxisTick: FunctionComponent<any> = (props: any) => {
  const { x, y, payload } = props;

  return (
    <g transform={`translate(${x},${y})`}>
      {/* Add a circle marker for every indicator */}
      <circle cx={0} cy={-8} r={4} fill="#CBCBCB" />
      <text x={0} y={0} dy={16} textAnchor="middle" fontSize={10} fill="#666">
        {payload.value}
      </text>
    </g>
  );
};

export default function ChartMin() {
  return (
    <LineChart
      width={350}
      height={310}
      data={data}
      margin={{
        top: 50,
        right: 30,
        left: 0,
        bottom: 10,
      }}
    >
      <CartesianGrid />
      
      <Tooltip />
      {/* <Legend /> */}
      <Line
        type="monotone"
        dataKey="pv"
        stroke="#92498E"
        strokeWidth="2px"
        dot={false}
      />
      <Line
        type="monotone"
        dataKey="uv"
        stroke="#1877F2"
        strokeWidth="2px"
        dot={false}
      />
    </LineChart>
  );
}